import { memo, useEffect } from 'react';

import { usePageHeaderContext } from './PageHeaderContext';
import { useElementRect } from '@page/core/hooks/dom/useElementRect';
import { PageHeaderFlex } from './PageHeaderFlex';
import { PageHeaderGrid } from './PageHeaderGrid';

export interface PageHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  titleClassName?: string;
  titleSuffix?: React.ReactNode;
  subTitle?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
  description?: React.ReactNode;
  descriptionClassName?: string;
}

const PageHeaderBase = ({ description, ...rest }: PageHeaderProps) => {
  const { ref, rect } = useElementRect();
  // TODO: Remove this and replace witht a better solution
  const { setHeight } = usePageHeaderContext();

  useEffect(() => {
    if (setHeight && rect.height) {
      setHeight(rect.height);
    }
  }, [rect.height, setHeight]);

  if (!description) {
    return <PageHeaderFlex ref={ref} {...rest} />;
  }

  return <PageHeaderGrid ref={ref} description={description} {...rest} />;
};

export const PageHeader = memo(PageHeaderBase);
